import { DialogType } from "providers/minimizedDialogs";
import { ComponentType } from "react";
import { DocumentAIAnalyzingDialog } from "components/Document";

const dialogRegistry: Record<
  DialogType,
  ComponentType<Record<string, unknown>>
> = {
  [DialogType.DocumentAIAnalyzing]: DocumentAIAnalyzingDialog as ComponentType<
    Record<string, unknown>
  >,
};

export function getDialogComponent(dialogType: DialogType) {
  return dialogRegistry[dialogType];
}
